/*
  BFS Add-to-basket reset v1.0 (Oct 2026)
  After a successful add the page jumps to the cart. If the shopper presses Back, the browser
  can restore the product page exactly as it was left (its back/forward cache), with the
  button still disabled and reading "Adding...". This puts the button back to normal when a
  page is restored that way. Applies to every configurator template.
*/
(function () {
  'use strict';

  var BTN = '[data-bfs-add-to-cart]';

  /* Remember each button's normal label the first time it is used. */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest(BTN);
    if (!b) return;
    var label = b.querySelector('[data-bfs-atc-label]');
    if (label && !b.hasAttribute('data-bfs-orig-label') && !/adding/i.test(label.textContent)) {
      b.setAttribute('data-bfs-orig-label', label.textContent);
    }
  }, true);

  function reset() {
    document.querySelectorAll(BTN).forEach(function (b) {
      b.disabled = false;
      b.classList.remove('is-loading');
      b.removeAttribute('aria-busy');
      var spin = b.querySelector('[data-bfs-atc-spinner]');
      if (spin) spin.classList.add('hidden');
      var label = b.querySelector('[data-bfs-atc-label]');
      if (label && /adding/i.test(label.textContent)) {
        label.textContent = b.getAttribute('data-bfs-orig-label') || 'Add to basket';
      }
    });
  }

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) reset();
  });
})();
